import { useState } from 'react';
import clienteAxios from '../../config/axios';
import { useT } from 'i18n';

export const REDES_USDT = ['TRC-20 (Tron)', 'ERC-20 (Ethereum)', 'BEP-20 (BNB Chain)', 'Solana', 'Polygon', 'Arbitrum', 'Optimism'];

const vacio = { bank_client: '', network: REDES_USDT[0], address_cripto: '' };

// Modal sencillo para guardar una wallet USDT propia. onGuardada() se llama al terminar bien.
const ModalNuevaWallet = ({ abierto, onCerrar, onGuardada }) => {
  const { t, ts } = useT();
  const [form, setForm] = useState(vacio);
  const [error, setError] = useState('');
  const [guardando, setGuardando] = useState(false);

  if (!abierto) return null;

  const cambiar = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const cerrar = () => { setForm(vacio); setError(''); onCerrar(); };

  const guardar = async (e) => {
    e.preventDefault();
    const direccion = form.address_cripto.trim();
    if (direccion.length < 20) { setError(t('modal.wDirCorta')); return; }
    setGuardando(true);
    setError('');
    try {
      await clienteAxios.post('/api/client/beneficiario_create', {
        bank_client: form.bank_client.trim(),
        network: form.network,
        address_cripto: direccion,
        bank_personal: '3',
      });
      setForm(vacio);
      onGuardada();
    } catch (err) {
      setError(ts(err.response?.data?.message) || t('modal.wNoGuardada'));
    } finally {
      setGuardando(false);
    }
  };

  return (
    <div className="p7-wallet-overlay" role="dialog" aria-modal="true" onClick={cerrar}>
      <form className="p7-wallet-card" onClick={(e) => e.stopPropagation()} onSubmit={guardar}>
        <h4>{t('modal.wTitulo')}</h4>
        <p className="p7-wallet-help">{t('modal.wAyuda')}</p>

        <label htmlFor="p7-w-alias">{t('modal.wAlias')}</label>
        <input id="p7-w-alias" name="bank_client" value={form.bank_client} onChange={cambiar} placeholder={t('modal.wAliasPh')} maxLength={50} required autoComplete="off" />

        <label htmlFor="p7-w-red">{t('modal.red')}</label>
        <select id="p7-w-red" name="network" value={form.network} onChange={cambiar}>
          {REDES_USDT.map((r) => <option key={r} value={r}>{r}</option>)}
        </select>

        <label htmlFor="p7-w-dir">{t('modal.wDirLabel')}</label>
        <input id="p7-w-dir" name="address_cripto" value={form.address_cripto} onChange={cambiar} placeholder={t('modal.wDirPh')} maxLength={120} required autoComplete="off" spellCheck={false} />

        {error && <div className="p7-wallet-error">{error}</div>}

        <div className="p7-wallet-actions">
          <button type="button" className="p7-btn-ghost" onClick={cerrar}>{t('modal.cancelar')}</button>
          <button type="submit" className="p7-btn-gold" disabled={guardando}>{guardando ? t('modal.guardando') : t('modal.wGuardar')}</button>
        </div>
      </form>
    </div>
  );
};

export default ModalNuevaWallet;
